/*

Usage <SimpleBar a={oneValue} b={anotherValue} highlightMax={false} className="aClass" highlightClassName="anotherClass"/>

a: mandatory left hand value
b: mandatory right hand value
highlightMax: optionally set this to false to suppress adding a class to the largest number
className: optionally set the base class for all the element. All sub classes will use this base.

*/
import PropTypes from 'prop-types';

import React from 'react';

export default function SimpleBar({
  a,
  b,
  highlightMax = true,
  className = "simple-bar"
}) {
  const svgWidth = 100;
  const svgHeight = 20;

  let proportion;

  if (a + b == 0) {
    proportion = 0.5;
    highlightMax = false; // force no highlighting
  }
  else {
    proportion = a / (a + b);
  }

  const widthA = svgWidth * proportion;
  const widthB = svgWidth - widthA;

  let highlightA = "";
  let highlightB = "";

  if (highlightMax) {
    const maxValue = Math.max(a, b);

    // highlight both in a draw
    highlightA = (a == maxValue) ? ` ${className}-highlighted`: "";
    highlightB = (b == maxValue) ? ` ${className}-highlighted`: "";
  }

  return (
    <div className={className}>
      <svg className={`${className}-bars`} viewBox={`0 0 ${svgWidth} ${svgHeight}`} preserveAspectRatio="none" xmlns="http://www.w3.</2000/svg">
        <rect className={`${className}-bar-a`} x="0" y="0" width={widthA} height={svgHeight} />
        <rect className={`${className}-bar-b`} x={widthA} y="0" width={widthB} height={svgHeight} />
      </svg>
      <span className={`${className}-text-a${highlightA}`}>{a}</span>
      <span className={`${className}-text-b${highlightB}`}>{b}</span>
    </div>
  );
}

SimpleBar.propTypes = {
  className: PropTypes.string,
  highlightMax: PropTypes.bool,
  a: PropTypes.number.isRequired,
  b: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./modules/Common/components/svg/SimpleBar.js